module.exports = __webpack_public_path__ + "static/media/Jungle Boy.5364ef33.jpg";